import * as Types from '../types-api.generated';

import { MarketCollectionFragment, UserLightFragment } from '../api-fragments.generated';
import { useQuery, useInfiniteQuery, UseQueryOptions, UseInfiniteQueryOptions, InfiniteData } from '@tanstack/react-query';
import { apiFetcher } from 'lib/clients/graphql';

import { ClientError } from "graphql-request";
import { Address } from "viem";
import { ChainId } from "lib/chains";

export type ApiCollectionsSearchVariables = Types.Exact<{
  searchTerm: Types.Scalars['String'];
  perPage?: Types.InputMaybe<Types.Scalars['Int']>;
  page?: Types.InputMaybe<Types.Scalars['Int']>;
}>;


export type ApiCollectionsSearch = { search: { page: number, items: Array<{ chainId: number, collectionImageUrl: string | null, contractAddress: string, contractType: Types.ApiContractType, coverImageUrl: string | null, createdAt: string, deletedAt: string | null, description: string | null, hiddenAt: string | null, id: string, isIndexed: boolean, isRevealed: boolean, moderationStatus: Types.ApiModerationStatus, name: string, slug: string, symbol: string | null, creator: { name: string | null, profileImageUrl: string | null, username: string | null, publicKey: Address } }> } };



export const ApiCollectionsSearchDocument = /*#__PURE__*/ `
    query CollectionsSearch($searchTerm: String!, $perPage: Int, $page: Int) {
  search: collectionsSearchDb(query: $searchTerm, perPage: $perPage, page: $page) {
    items {
      ...MarketCollectionFragment
    }
    page
  }
}
    ${MarketCollectionFragment}
${UserLightFragment}`;

export const useCollectionsSearch = <
      TData = ApiCollectionsSearch,
      TError = ClientError
    >(
      variables: ApiCollectionsSearchVariables,
      options?: Omit<UseQueryOptions<ApiCollectionsSearch, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ApiCollectionsSearch, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ApiCollectionsSearch, TError, TData>(
      {
    queryKey: ['CollectionsSearch', variables],
    queryFn: apiFetcher<ApiCollectionsSearch, ApiCollectionsSearchVariables>(ApiCollectionsSearchDocument, variables),
    ...options
  }
    )};

useCollectionsSearch.getKey = (variables: ApiCollectionsSearchVariables) => ['CollectionsSearch', variables];

export const useInfiniteCollectionsSearch = <
      TData = InfiniteData<ApiCollectionsSearch>,
      TError = ClientError
    >(
      variables: ApiCollectionsSearchVariables,
      options: Omit<UseInfiniteQueryOptions<ApiCollectionsSearch, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ApiCollectionsSearch, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<ApiCollectionsSearch, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['CollectionsSearch.infinite', variables],
      queryFn: (metaData) => apiFetcher<ApiCollectionsSearch, ApiCollectionsSearchVariables>(ApiCollectionsSearchDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteCollectionsSearch.getKey = (variables: ApiCollectionsSearchVariables) => ['CollectionsSearch.infinite', variables];


useCollectionsSearch.fetcher = (variables: ApiCollectionsSearchVariables, options?: RequestInit['headers']) => apiFetcher<ApiCollectionsSearch, ApiCollectionsSearchVariables>(ApiCollectionsSearchDocument, variables, options);
